import { ComponentProps, useState } from 'react';

import { ProductImageFallback } from '@/components/ProductImageFallback';
import { useAuth } from '@/contexts/AuthContext';
import { cn, priceFormatterV2 } from '@/lib/utils';
import { SearchProduct } from '@/services/ProductsService';

interface ProductCardProps {
  product: SearchProduct | undefined;
}

function Image(props: ComponentProps<'img'>) {
  const [error, setError] = useState(false);

  if (error) {
    return <ProductImageFallback />;
  }

  return (
    <img
      className="rounded-t-lg transition-transform duration-300 hover:scale-110"
      {...props}
      onError={() => setError(true)}
    />
  );
}

export function SearchProductCard({ product }: ProductCardProps) {
  const { user } = useAuth();

  const formattedPrice = parseFloat(product?.price || '0');
  const formattedSalePrice = parseFloat(product?.salePrice || '0');

  return (
    <div className="rounded-lg bg-white shadow-sm transition-shadow duration-200 hover:shadow-md">
      <div className="overflow-hidden rounded-t-lg">
        <Image src={product?.image1} alt={product?.name} />
      </div>

      <div className="h-20 flex-col p-5 font-light">
        <span className="block truncate text-xs">{product?.name}</span>

        {formattedPrice > 0 && formattedSalePrice > 0 && (
          <div className="mt-1 flex gap-2 text-sm">
            {formattedSalePrice < formattedPrice && (
              <span className="line-through opacity-50">
                {priceFormatterV2(
                  formattedPrice,
                  user!.customer.language,
                  user!.customer.platform,
                )}
              </span>
            )}

            <span
              className={cn(
                'opacity-90',
                formattedSalePrice < formattedPrice &&
                  'font-semibold text-red-400',
              )}
            >
              {priceFormatterV2(
                formattedSalePrice,
                user!.customer.language,
                user!.customer.platform,
              )}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
